import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["notificationFields", "workflowFields"];

  toggleAction(event) {
    const value = event.target.value;
    if (this.hasNotificationFieldsTarget) {
      this.notificationFieldsTarget.classList.toggle("no-show", value !== "send_notification");
    }
    if (this.hasWorkflowFieldsTarget) {
      this.workflowFieldsTarget.classList.toggle("no-show", value !== "trigger_workflow");
    }
  }

  // The message field owns drafting, so this hands off rather than reaching across.
  draftIfNotifying(event) {
    if (event.target.value !== "send_notification") return;

    const field = this.element.querySelector("[data-controller~='message-draft']");
    this.application.getControllerForElementAndIdentifier(field, "message-draft")?.draftIfEmpty();
  }
}
